module.exports = __webpack_public_path__ + "static/media/xepelin-logo-login.7b3b3582.svg";